<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content" [ngClass]="{ yellow: pending }">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div class="ui basic segment" *ngIf="success || error">
      <div class="ui success message" *ngIf="success">
        <i (click)="close()" class="close icon"></i>
        {{ success }}
      </div>
      <div class="ui warning message" *ngIf="error">
        <i (click)="close()" class="close icon"></i>
        {{ error | json }}
      </div>
    </div>
    <div class="ui form">
      <div class="field">
        <label class="required">Select Users</label>
        <div class="ui mini icon input">
          <input
            type="text"
            placeholder="Search Users"
            [formControl]="search"
          />
          <i class="search icon"></i>
        </div>

        <div class="ui segment" id="wrapper">
          <app-tabset>
            <div class="ui pointing secondary menu">
              <a
                class="item"
                style="
                  width: 50%;
                  text-align: center;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
                appTabHeader="1"
                >Users in Group
              </a>
              <a
                class="item"
                style="
                  width: 50%;
                  text-align: center;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
                appTabHeader="2"
                >Unassigned Users</a
              >
            </div>
            <div class="ui basic segment" appTabContent="1">
              <div
                class="option"
                fxLayout="row"
                *ngFor="let user of selectedUsers"
                style="
                  background-color: #f9fafb;
                  border-radius: 10px;
                  height: 92px;
                "
                fxLayoutAlign="space-between center"
                marginX="0"
                appPadding
                paddingL="20px"
                paddingY="10px"
                paddingR="10px"
                appMargin
                marginY="10px"
              >
                <div
                  fxFlex="grow"
                  fxLayout="row"
                  fxLayoutGap="15px"
                  fxLayoutAlign="start center"
                >
                  <div>
                    <img
                      style="width: 50px"
                      src="../../../../../assets/avatar/1.jpg"
                      alt="image"
                      class="ui tiny circular image avatar"
                    />
                  </div>
                  <div fxLayout="column" fxLayoutGap="10px">
                    <div class="ui header fw-bold" style="font-size: 15px">
                      {{ user?.name || "-" }}
                    </div>
                    <div
                      *ngIf="user?.active"
                      style="width: 50px"
                      class="ui circular mini green label"
                    >
                      ACTIVE
                    </div>
                    <div
                      *ngIf="!user?.active"
                      style="width: 55px"
                      class="ui circular mini red label"
                    >
                      INACTIVE
                    </div>
                  </div>
                </div>
                <div fxFlex="auto">
                  <button class="ui tiny icon button" (click)="onDelete(user)">
                    <i class="ui trash icon"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="ui basic segment" appTabContent="2">
              <div
                class="option"
                fxLayout="row"
                *ngFor="let user of unselectedUsers"
                style="background-color: #f0f1f8; border-radius: 10px"
                fxLayoutAlign="space-between center"
                marginX="0"
                appPadding
                paddingL="20px"
                paddingY="10px"
                paddingR="10px"
                appMargin
                marginY="10px"
              >
                <div
                  fxFlex="grow"
                  fxLayout="row"
                  fxLayoutGap="15px"
                  fxLayoutAlign="start center"
                >
                  <div>
                    <img
                      style="width: 50px"
                      src="../../../../../assets/avatar/1.jpg"
                      alt="image"
                      class="ui tiny circular image avatar"
                    />
                  </div>
                  <div fxLayout="column" fxLayoutGap="10px">
                    <div class="ui header fw-bold" style="font-size: 15px">
                      {{ user?.name || "-" }}
                    </div>
                    <div
                      *ngIf="user?.active"
                      style="width: 50px"
                      class="ui circular mini green label"
                    >
                      ACTIVE
                    </div>
                    <div
                      *ngIf="!user?.active"
                      style="width: 55px"
                      class="ui circular mini red label"
                    >
                      INACTIVE
                    </div>
                  </div>
                </div>
                <div fxFlex="auto">
                  <input
                    class="checkbox"
                    [checked]="isChecked(user.appUserId)"
                    name="read"
                    type="checkbox"
                    (change)="checkChange(user.appUserId, $event)"
                  />
                  <!-- <sui-checkbox [(ngModel)]="user.selected"></sui-checkbox> -->
                </div>
              </div>
            </div>
          </app-tabset>
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    <button class="ui button back" (click)="modal.deny(undefined)">
      Cancel
    </button>
    <button
      class="ui primary button"
      [ngClass]="{ yellow: pending }"
      [disabled]="pending || selectedUsers.length < 1"
      autofocus
      (click)="onAssign()"
    >
      Done
    </button>
  </div>
</div>
